/**
 * Created by bob.gear on 27/03/2017.
 */
//import * as angular from 'angular';
var EICDataStream3Resources = angular.module("EICDataStream3.resources", ["ngResource"])
  .config(function() {
  });

//-------------------------------------------------------------------------
// Resource Declarations
//-------------------------------------------------------------------------
// Project Search Type
//-------------------------------------------------------------------------
EICDataStream3Resources.factory('projects', ['$resource', function ($resource) {
  return $resource('/api/projectsummary/:guid', { guid: '@guid' }, { update: { method: 'PUT' }, list: { cache: true } });
}]);

EICDataStream3Resources.factory('recentlyAddedProjects', ['$resource', function ($resource) {
  return $resource('/api/recentlyaddedprojects/:id', { id: '@id' }, { update: { method: 'PUT' }, list: { cache: true } });
}]);
EICDataStream3Resources.factory('recentlyAwardedContracts', ['$resource', function ($resource) {
  return $resource('/api/recentlyawardedcontracts/:id', { id: '@id' }, { update: { method: 'PUT' }, list: { cache: true } });
}]);
EICDataStream3Resources.factory('projectNames', ['$resource', function($resource) {
  return $resource('/api/projectname/:id', { id: '@id' }, { update: { method: 'PUT' }, list: { cache: true } });
}]);
EICDataStream3Resources.factory('projectCount', ['$resource', function ($resource) {
  return $resource('/api/projectcount/:id', { id: '@id' }, { update: { method: 'PUT' }, list: { cache: true } });
}]);

EICDataStream3Resources.factory('project', ['$resource', function($resource) {
  return $resource('/api/project/:id', { id: '@id' }, { update: { method: 'PUT' } });
}]);

EICDataStream3Resources.factory('projectNotes', ['$resource', function($resource) {
  return $resource('/api/projectNote/:id', { id: '@id' }, { update: { method: 'PUT' } });
}]);

EICDataStream3Resources.factory('projectOperatingCompanies', ['$resource', function($resource) {
  return $resource('/api/project/:projectID/operatingCompanies/:id', { projectID: '@projectID', id: '@id' }, { update: { method: 'PUT' } });
}]);

EICDataStream3Resources.factory('projectLocations', ['$resource', function ($resource) {
  return $resource('/api/project/:projectID/projectLocations/:id', { projectID: '@projectID', id: '@id' }, { update: { method: 'PUT' } });
}]);

EICDataStream3Resources.factory('projectRelatedProjects', ['$resource', function ($resource) {
  return $resource('/api/project/:projectID/projectRelatedProjects/:id', { projectID: '@projectID', id: '@id' }, { update: { method: 'PUT' } });
}]);

EICDataStream3Resources.factory('projectLinks', ['$resource', function ($resource) {
  return $resource('/api/project/:projectID/projectLinks/:id', { projectID: '@projectID', id: '@id' }, { update: { method: 'PUT' } });
}]);

EICDataStream3Resources.factory('projectContracts', ['$resource', function ($resource) {
  return $resource('/api/project/:projectID/projectContracts/:id', { projectID: '@projectID', id: '@id' }, { update: { method: 'PUT' } });
}]);

EICDataStream3Resources.factory('projectTypes', ['$resource', function ($resource) {
  return $resource('/api/projectTypes/:projectID', { projectID: '@projectID' }, { update: { method: 'PUT' } });
}]);

EICDataStream3Resources.factory('savedSearches', ['$resource', function($resource) {
  return $resource('/api/savedsearches/:guid', { guid: '@guid' },
    {
      'get': { method: 'GET' },
      'create': { method: 'POST' },
      'update': { method: 'PUT' },
      'query': { method: 'GET', isArray: true },
      'remove': { method: 'DELETE' },
      'delete': { method: 'DELETE' }
    });
}]);
EICDataStream3Resources.factory('projectWatch', ['$resource', function($resource) {
  return $resource('/api/projectwatch/:guid', { id: '@searchGuid'
    },
    {
      'get': { method: 'GET' },
      'create': { method: 'POST' },
      'update': { method: 'PUT' },
      'query': { method: 'GET', isArray: true },
      'remove': { method: 'DELETE' },
      'delete': { method: 'DELETE' }
    });
}]);


EICDataStream3Resources.factory('savedSearchListItems', ['$resource', function ($resource) {
  return $resource('/api/savedsearchlistitems/:value', { value: '@value' },
    {
      'rename': { method: 'PUT' },
      'query':  { method: 'GET', isArray: true }
    });
}]);

EICDataStream3Resources.factory('lastSearch', ['$resource', function ($resource) {
  return $resource('/api/lastSearch');
}]);

EICDataStream3Resources.factory('favouriteLists', ['$resource', function ($resource) {
  return $resource('/api/favouriteLists/:guid', { guid: '@guid' },
    {
      update: { method: 'PUT' },
      delete: { method: 'DELETE' },
      query: { method: 'GET', cache: true, isArray: true }
    });
}]);
EICDataStream3Resources.factory('favouriteList', ['$resource', function ($resource) {
  return $resource('/api/favouriteList/:favouriteListGuid', { id: '@favouriteListGuid' }, {update: { method: 'PUT' }});
}]);
//-------------------------------------------------------------------------

////-------------------------------------------------------------------------
//// Watches
////-------------------------------------------------------------------------
//EICDataStream3Resources.factory('favouriteList', ['$resource', function ($resource) {
//  return $resource('/api/favouriteList/:favouriteListGuid', { id: '@favouriteListGuid' }, {update: { method: 'PUT' }});
//}]);
////-------------------------------------------------------------------------


//-------------------------------------------------------------------------
// MemberNotes
//-------------------------------------------------------------------------
EICDataStream3Resources.factory('memberNote', ['$resource', function ($resource) {
  return $resource('/api/memberNote/:noteID', { noteID: '@noteID' },
    {
      update: { method: 'PUT',    interceptor: { response: resourceStatusResponseInterceptor } },
      save:   { method: 'POST',   interceptor: { response: resourceStatusResponseInterceptor } },
      get:    { method: 'GET',    interceptor: { response: resourceStatusResponseInterceptor } },
      delete: { method: 'DELETE', interceptor: { response: resourceStatusResponseInterceptor } }
    });
}]);
//-------------------------------------------------------------------------
var resourceStatusResponseInterceptor = function (response) {
  var result = response.resource;
  result.$status = response.status;
  return result;
};


//-------------------------------------------------------------------------
// Contract Award Search Type
//-------------------------------------------------------------------------
EICDataStream3Resources.factory('contractAwards', ['$resource', function($resource) {
  return $resource('/api/contractawardsummary/:guid', { guid: '@guid' }, { update: { method: 'PUT' }, list: { cache: true } });
}]);

EICDataStream3Resources.factory('contract', ['$resource', function ($resource) {
  return $resource('/api/contract/:id', { id: '@id' }, { update: { method: 'PUT' } });}]);
//-------------------------------------------------------------------------


////-------------------------------------------------------------------------
//// Legacy Report Service
////-------------------------------------------------------------------------
//EICDataStream3Resources.factory('enqueueLegacyReport', ['$resource', function ($resource) {
//  return $resource('/api/enqueueLegacyReport/', { }, { update: { method: 'PUT' }, list: { cache: true } });
//}]);
////-------------------------------------------------------------------------


////-------------------------------------------------------------------------
//// PDF Reports
////-------------------------------------------------------------------------
EICDataStream3Resources.factory('pdfReports', ['$resource', function ($resource) {
  return $resource('/api/pdfreports/', { }, { update: { method: 'PUT' }, list: { cache: true } });
}]);
////-------------------------------------------------------------------------


////-------------------------------------------------------------------------
//// Legacy PDF Reports
////-------------------------------------------------------------------------
//EICDataStream3Resources.factory('legacyPdfReports', ['$resource', function ($resource) {
//  return $resource('/api/legacypdfreports/', {}, { update: { method: 'PUT' }, list: { cache: true } });
//}]);
////-------------------------------------------------------------------------